import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'hourDecimalToHHMM',
})
export class HourDecimalToHHMMPipe implements PipeTransform {
  constructor() {}

  transform(timeDecimal: number, roundTo: number = 15): string {
    if (timeDecimal == null) {
      return '--:--';
    }

    let hours = Math.floor(timeDecimal);
    let minutes = Math.round((timeDecimal - hours) * 60);

    // Round minutes to the nearest 5-minute interval
    minutes = Math.round(minutes / roundTo) * roundTo;

    if (minutes === 60) {
      minutes = 0;
      hours++;
    }

    // Format hours and minutes as HH:MM
    const HH = hours.toString().padStart(2, '0');
    const MM = minutes.toString().padStart(2, '0');

    return `${HH}:${MM}`;
  }
}
